<template>
  <div class="relative w-full">
    <!-- Button showing selected items -->
    <button
      type="button"
      @click="toggleDropdown"
      class="inline-flex w-full justify-between rounded-md border border-gray-300 bg-gray-50 px-4 py-2 h-custom-dropdown text-sm text-gray-500 hover:bg-gray-50 focus:outline-none"
    >
      <span class="flex flex-wrap gap-1 relative">
        <span v-if="selectedOptions.length === 0" class="text-gray-500 font-medium mt-0.5">{{ defaultText }}</span>
        <span
          v-for="item in selectedOptions"
          :key="item.value"
          class="bg-blue-100 text-blue-800 px-2 text-xs py-1 rounded-lg flex items-center gap-1"
        >
          {{ item.text }}
          <button type="button" @click.stop="removeOption(item.value)" class="font-bold">×</button>
        </span>
      </span>
      <svg class="ml-2 -mr-1 h-5 w-5 absolute right-4 top-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isOpen" class="absolute right-0 z-10 mt-2 w-full rounded-md bg-white border shadow max-h-60 overflow-auto">
      <div class="p-2">
        <label
          v-for="option in options"
          :key="option.value"
          class="flex items-center p-2 cursor-pointer hover:bg-gray-100"
        >
          <input
            type="checkbox"
            :value="option.value"
            v-model="selectedValues"
            class="form-checkbox h-4 w-4 rounded-sm text-blue-600"
          />
          <span class="ml-2 text-gray-700">{{ option.text }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusFilterComponentMultiple',
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    defaultText: { type: String, default: 'Select Content Status' }
  },
  data() {
    return {
      isOpen: false,
      filterByStatus: []
    };
  },
  computed: {
    selectedValues: {
      get() {
        return this.filterByStatus.length ? this.filterByStatus : this.value;
      },
      set(val) {
        this.filterByStatus = val;
        this.$emit('input', val);
      }
    },
    selectedOptions() {
      return this.options.filter(opt => this.selectedValues.includes(opt.value));
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    removeOption(value) {
      this.selectedValues = this.selectedValues.filter(v => v !== value);
    },
    handleClickOutside(event) {
      if (this.isOpen && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  watch: {
    value(newVal) {
      this.filterByStatus = Array.isArray(newVal) ? [...newVal] : [];
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.filterByStatus = Array.isArray(this.value) ? [...this.value] : [];
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>
<style>
  .h-custom-dropdown {
    min-height: 43px;
  }
  .form-checkbox:focus, .form-radio:focus {
    outline: 0px solid transparent !important;
    outline-offset: 0px !important;
    --tw-ring-inset: var(--tw-empty, );
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: transparent !important;
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
</style>
